import type { RenderSlideProps } from 'yet-another-react-lightbox';
import { Video } from '../video';
import type { GalleryMediaSlide } from './lightbox-types';

export default function LightboxVideo({ slide, rect }: RenderSlideProps) {
  const mediaSlide = slide as GalleryMediaSlide;
  if (mediaSlide.type !== 'video') return null;

  // Choose resolution based on viewport size
  const resolution = rect.width >= 1280 ? 'HD' : 'SD';

  // Parse aspect ratio (format: "16:9")
  const [width, height] = (mediaSlide.aspectRatio || '16:9')
    .split(':')
    .map(Number);
  const aspectRatio = (width ?? 16) / (height ?? 9);

  const maxHeight = rect.height;
  const maxWidth = rect.width;

  let containerWidth = maxWidth;
  let containerHeight = containerWidth / aspectRatio;

  // If height exceeds container, scale down maintaining aspect ratio
  if (containerHeight > maxHeight) {
    containerHeight = maxHeight;
    containerWidth = containerHeight * aspectRatio;
  }

  return (
    <div
      style={{
        position: 'relative',
        width: rect.width,
        height: rect.height,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          width: containerWidth,
          height: containerHeight,
          position: 'relative',
        }}
      >
        <Video
          playbackId={mediaSlide.playbackId}
          resolution={resolution}
          controlled
          loading="eager"
          className="h-full w-full"
        />
      </div>
    </div>
  );
}
